import {
  PatchSubscriptionLinkPathParamsType,
  PatchSubscriptionLinkRequestBodyType,
  PatchSubscriptionLinkResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const patchStripeSubscriptionLink = async (
  payload: ApiRequest<
    PatchSubscriptionLinkRequestBodyType,
    PatchSubscriptionLinkPathParamsType
  >
) => {
  const resp = await api.patch<
    PatchSubscriptionLinkResponseBodyType,
    PatchSubscriptionLinkRequestBodyType
  >(
    `/v2/admin/subscription-links/${payload.pathParams.subscriptionLinkId}`,
    payload.body
  );
  return resp.data;
};

export const useAdminPatchStripeSubscriptionLink = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PatchSubscriptionLinkResponseBodyType,
    Error,
    ApiRequest<
      PatchSubscriptionLinkRequestBodyType,
      PatchSubscriptionLinkPathParamsType
    >
  >({
    mutationFn: async (
      payload: ApiRequest<
        PatchSubscriptionLinkRequestBodyType,
        PatchSubscriptionLinkPathParamsType
      >
    ) => patchStripeSubscriptionLink(payload),

    // onSuccess: (data, variables, context) => {
    //   queryClient.setQueryData(
    //     organizationsKeys.orgSummaries,
    //     (oldData: GetAdminOrganizationsResponseBodyType) => {
    //       const orgIndex = oldData.orgs.findIndex(
    //         (org) => org.id === variables.body.organizationId
    //       );
    //
    //       if (orgIndex === -1) {
    //         return oldData;
    //       }
    //
    //       const subscriptionIndex = oldData.orgs[
    //         orgIndex
    //       ].subscriptions.findIndex(
    //         (subscription) =>
    //           subscription.subscriptionLinkId ===
    //           variables.pathParams.subscriptionLinkId
    //       );
    //
    //       if (subscriptionIndex === -1) {
    //         return oldData;
    //       }
    //
    //       oldData.orgs[orgIndex].subscriptions[subscriptionIndex] = {
    //         ...oldData.orgs[orgIndex].subscriptions[subscriptionIndex],
    //         internalNotes: data.stripeSubscriptionLink.internalNotes,
    //         autoScale: data.stripeSubscriptionLink.autoScale,
    //       };
    //
    //       return oldData;
    //     }
    //   );
    // },
  });
};
